// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NGOjDCY3Hs7ji9dl {
  width: 1184px;
  max-width: 100%;
  margin: 0 auto;
  padding: 40px 0 96px;
  box-sizing: border-box;
}

.iDtCm0HkRlA9tE5R {
  font-family: Roboto, sans-serif;
  font-weight: 600;
  font-size: 32px;
  line-height: 120%;
  letter-spacing: 0;
  text-transform: capitalize;
  color: rgba(0, 0, 0, 1);
  margin: 0 0 16px;
}

.PJM0I6PcsEhLGUCl {
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0;
  color: rgba(0, 0, 0, 0.7);
  margin: 0 0 40px;
}

.mbrHImJ_DFQaMHwM {
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.6);
  margin: 0 0 8px;
}

.pZmoZqOtbB44O8Pw {
  height: 32px;
}

.dQQolFZwrA078IiA {
  background: rgba(249, 249, 249, 1);
  border-radius: 16px;
  padding: 8px 24px;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
}

.s0KTWJoQTIZiqXFZ {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.s0KTWJoQTIZiqXFZ:last-child {
  border-bottom: none;
}

.oXnrxAbxa2AXl0lR {
  width: 56px;
  height: 56px;
  background: rgba(238, 241, 255, 1);
  border-radius: 8px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.oXnrxAbxa2AXl0lR img {
  width: 24px;
  height: 24px;
  display: block;
}

.oXnrxAbxa2AXl0lR .pi {
  font-size: 24px;
  color: rgba(32, 51, 108, 1);
}

.vOSiXovSGgkV_Bnr {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.oaIaqAaR0UEGBso2 {
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0;
  color: rgba(0, 0, 0, 1);
}

.nyipSZWx2lQfKBDA {
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0;
  color: rgba(0, 0, 0, 0.7);
}

.FShdQLvNJo173l8D {
  flex-shrink: 0;
}

.FShdQLvNJo173l8D .p-inputswitch {
  width: 51px;
  height: 31px;
}

.FShdQLvNJo173l8D .p-inputswitch .p-inputswitch-slider {
  border-radius: 100px !important;
  background: rgba(0, 0, 0, 0.16) !important;
  transition: background-color 0.2s !important;
}

.FShdQLvNJo173l8D .p-inputswitch .p-inputswitch-slider:before {
  width: 25px;
  height: 25px;
  margin-top: -12.5px;
  left: 3px;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.FShdQLvNJo173l8D .p-inputswitch.p-highlight .p-inputswitch-slider,
.FShdQLvNJo173l8D .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
  background: rgba(32, 51, 108, 1) !important;
}

.FShdQLvNJo173l8D .p-inputswitch.p-highlight .p-inputswitch-slider:before,
.FShdQLvNJo173l8D
  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
  transform: translateX(20px);
  background: #ffffff;
}

.FShdQLvNJo173l8D .p-inputswitch:not(.p-disabled):hover .p-inputswitch-slider,
.FShdQLvNJo173l8D
  .p-inputswitch:not(.p-disabled):has(.p-inputswitch-input:hover)
      .p-inputswitch-slider {
  background: rgba(0, 0, 0, 0.24) !important;
}

.FShdQLvNJo173l8D
  .p-inputswitch.p-highlight:not(.p-disabled):hover .p-inputswitch-slider,
.FShdQLvNJo173l8D
  .p-inputswitch.p-highlight:not(.p-disabled):has(.p-inputswitch-input:hover)
      .p-inputswitch-slider,
.FShdQLvNJo173l8D
  .p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover
      .p-inputswitch-slider {
  background: #1a2a5a !important;
}

.QFFE4j0kHw0p4h7O {
  width: 100%;
  position: relative;
}

.QFFE4j0kHw0p4h7O .p-multiselect {
  width: 100%;
  min-height: 66px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  border: none !important;
  outline: none !important;
  display: flex;
  align-items: stretch;
}

.QFFE4j0kHw0p4h7O .p-multiselect-label-container {
  overflow: visible;
  display: flex;
  align-items: center;
}

.QFFE4j0kHw0p4h7O .p-multiselect:not(.p-disabled).p-focus,
.QFFE4j0kHw0p4h7O .p-multiselect:not(.p-disabled):hover {
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  border: none !important;
  outline: none !important;
}

.QFFE4j0kHw0p4h7O .p-multiselect-label {
  padding: 10px 60px 10px 26px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  height: auto;
  white-space: normal;
}

.QFFE4j0kHw0p4h7O .p-multiselect-token {
  height: 46px;
  background: rgba(32, 51, 108, 0.15);
  color: rgba(48, 48, 48, 1);
  border-radius: 23px;
  padding: 0 18px;
  margin: 0;
  font-family: Jost, Roboto, sans-serif;
  font-weight: 400;
  font-size: 21px;
  line-height: 1;
  letter-spacing: 0;
  text-align: center;
  text-transform: capitalize;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-sizing: border-box;
}

.QFFE4j0kHw0p4h7O .p-multiselect-token .p-multiselect-token-label {
  flex: none;
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.QFFE4j0kHw0p4h7O .p-multiselect-token-icon {
  color: rgba(48, 48, 48, 1);
  width: 11px;
  height: 11px;
  font-size: 11px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.QFFE4j0kHw0p4h7O .p-multiselect-token-icon svg {
  display: block;
  width: 100%;
  height: 100%;
}

.QFFE4j0kHw0p4h7O .p-multiselect-trigger {
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 30px;
  box-sizing: border-box;
  color: rgba(164, 164, 164, 1);
}

.QFFE4j0kHw0p4h7O .p-multiselect-trigger-icon,
.QFFE4j0kHw0p4h7O .p-multiselect-trigger svg {
  width: 30px;
  height: 12px;
  color: rgba(164, 164, 164, 1);
}

.LUt8d0T8SkQBdW4_ {
  position: absolute !important;
  top: calc(100% + 8px) !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  transform: none !important;
  border-radius: 24px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06) !important;
  padding: 24px;
  overflow: hidden;
  z-index: 1000;
  border: none !important;
}

.LUt8d0T8SkQBdW4_ .p-multiselect-header {
  display: none;
}

.LUt8d0T8SkQBdW4_ .p-multiselect-items-wrapper {
  max-height: none !important;
  overflow: visible !important;
}

.LUt8d0T8SkQBdW4_ .p-multiselect-items {
  margin: 0;
  padding: 0;
}

.LUt8d0T8SkQBdW4_ .p-multiselect-items li {
  min-height: 57px;
  border-radius: 15px;
  margin: 4px 0;
  padding: 0 24px;
  display: flex;
  align-items: center;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 21px;
  line-height: 100%;
  letter-spacing: 0;
  text-transform: capitalize;
  color: rgba(48, 48, 48, 1);
  background: rgba(255, 255, 255, 1) !important;
  border: 1px solid transparent;
  transition: border-color 0.15s;
}

.LUt8d0T8SkQBdW4_ .p-multiselect-item > span:not(.IxTMDWD4jFEFMxdl) {
  flex: 1;
  min-width: 0;
}

.LUt8d0T8SkQBdW4_ .p-multiselect-checkbox {
  display: none;
}

.LUt8d0T8SkQBdW4_
  .p-multiselect-item:not(.p-highlight):not(.p-disabled):hover,
.LUt8d0T8SkQBdW4_ .p-multiselect-item.p-focus:not(.p-highlight) {
  background: rgba(255, 255, 255, 1) !important;
  color: rgba(48, 48, 48, 1) !important;
  border: 1px solid rgba(32, 51, 108, 1) !important;
  border-radius: 15px;
}

.LUt8d0T8SkQBdW4_ .p-multiselect-item.p-highlight,
.LUt8d0T8SkQBdW4_ .p-multiselect-item.p-highlight:hover,
.LUt8d0T8SkQBdW4_ .p-multiselect-item.p-highlight.p-focus {
  background: rgba(32, 51, 108, 1) !important;
  color: rgba(255, 255, 255, 1) !important;
  border: 1px solid transparent !important;
}

.nOn2Sb3E5k1y2Ya5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}

.Qiqs2RcNuvk9chEY {
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 21px;
  line-height: 100%;
  letter-spacing: 0;
  text-transform: capitalize;
  color: rgba(48, 48, 48, 1);
}

.vLF9_KfxJ6gI2GzJ {
  width: 27px;
  height: 19.5px;
  flex-shrink: 0;
  display: block;
}

@media screen and (max-width: 1240px) {
  .NGOjDCY3Hs7ji9dl {
    padding-left: 28px;
    padding-right: 28px;
  }
}

@media screen and (max-width: 1024px) {
  .NGOjDCY3Hs7ji9dl {
    padding: 32px 24px 80px;
  }

  .QFFE4j0kHw0p4h7O .p-multiselect-label {
    padding: 10px 56px 10px 20px;
    gap: 8px;
  }
}

@media screen and (max-width: 768px) {
  .NGOjDCY3Hs7ji9dl {
    padding: 24px 16px 80px;
  }

  .iDtCm0HkRlA9tE5R {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 16px;
  }

  .PJM0I6PcsEhLGUCl {
    font-size: 12px;
    margin-bottom: 32px;
  }

  .mbrHImJ_DFQaMHwM {
    font-size: 12px;
    margin-bottom: 8px;
  }

  .dQQolFZwrA078IiA {
    padding: 16px;
  }

  .s0KTWJoQTIZiqXFZ {
    gap: 10px;
  }

  .oaIaqAaR0UEGBso2 {
    font-size: 16px;
  }

  .nyipSZWx2lQfKBDA {
    font-size: 14px;
  }

  .oXnrxAbxa2AXl0lR {
    width: 48px;
    height: 48px;
    padding: 12px;
  }

  .oXnrxAbxa2AXl0lR img {
    width: 20px;
    height: 20px;
  }

  .QFFE4j0kHw0p4h7O .p-multiselect {
    min-height: 56px;
    border-radius: 18px;
  }

  .QFFE4j0kHw0p4h7O .p-multiselect-label {
    padding: 8px 48px 8px 16px;
    gap: 8px;
  }

  .QFFE4j0kHw0p4h7O .p-multiselect-token {
    height: 38px;
    padding: 0 14px;
    font-size: 16px;
    border-radius: 19px;
    gap: 10px;
  }

  .QFFE4j0kHw0p4h7O .p-multiselect-trigger {
    width: 48px;
    justify-content: flex-end;
    padding-right: 24px;
    box-sizing: border-box;
  }

  .QFFE4j0kHw0p4h7O .p-multiselect-trigger-icon,
  .QFFE4j0kHw0p4h7O .p-multiselect-trigger svg {
    width: 22px;
    height: 10px;
  }

  .LUt8d0T8SkQBdW4_ {
    padding: 16px;
    border-radius: 18px;
  }

  .LUt8d0T8SkQBdW4_ .p-multiselect-items li {
    min-height: 48px;
    padding: 0 16px;
    font-size: 16px;
  }

  .Qiqs2RcNuvk9chEY {
    font-size: 16px;
  }

  .vLF9_KfxJ6gI2GzJ {
    width: 22px;
    height: 16px;
  }
}

@media screen and (max-width: 480px) {
  .NGOjDCY3Hs7ji9dl {
    padding: 32px 24px;
  }

  .pZmoZqOtbB44O8Pw {
    height: 24px;
  }

  .dQQolFZwrA078IiA {
    padding: 16px;
  }

  .s0KTWJoQTIZiqXFZ {
    padding: 16px 0;
    gap: 12px;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .s0KTWJoQTIZiqXFZ:first-child {
    padding-top: 0;
  }

  .s0KTWJoQTIZiqXFZ:last-child {
    padding-top: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .oXnrxAbxa2AXl0lR {
    width: 48px;
    height: 48px;
    padding: 12px;
    border-radius: 8px;
  }

  .oXnrxAbxa2AXl0lR img {
    width: 24px;
    height: 24px;
  }

  .vOSiXovSGgkV_Bnr {
    gap: 8px;
  }

  .oaIaqAaR0UEGBso2 {
    font-size: 16px;
    font-weight: 500;
  }

  .nyipSZWx2lQfKBDA {
    font-size: 12px;
    font-weight: 400;
  }

  .FShdQLvNJo173l8D .p-inputswitch {
    width: 51px;
    height: 31px;
  }

  .FShdQLvNJo173l8D .p-inputswitch .p-inputswitch-slider:before {
    width: 25px;
    height: 25px;
    margin-top: -12.5px;
    left: 3px;
  }

  .FShdQLvNJo173l8D .p-inputswitch.p-highlight .p-inputswitch-slider:before,
  .FShdQLvNJo173l8D
    .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
    transform: translateX(20px);
  }

  .QFFE4j0kHw0p4h7O .p-multiselect {
    min-height: 44px;
    border-radius: 16px;
    background: rgba(249, 249, 249, 0.98);
  }

  .QFFE4j0kHw0p4h7O .p-multiselect-label {
    padding: 7px 22px 7px 12px;
    gap: 4px;
  }

  .QFFE4j0kHw0p4h7O .p-multiselect-token {
    height: 30px;
    padding: 0 9.78px;
    font-size: 13.7px;
    border-radius: 15px;
    gap: 8px;
  }

  .QFFE4j0kHw0p4h7O .p-multiselect-token-icon {
    width: 8px;
    height: 8px;
    font-size: 8px;
  }

  .QFFE4j0kHw0p4h7O .p-multiselect-trigger {
    width: 32px;
    justify-content: flex-end;
    padding-right: 16px;
    box-sizing: border-box;
  }

  .QFFE4j0kHw0p4h7O .p-multiselect-trigger-icon,
  .QFFE4j0kHw0p4h7O .p-multiselect-trigger svg {
    width: 14.74px;
    height: 8.31px;
  }

  .LUt8d0T8SkQBdW4_ {
    padding: 16px;
    border-radius: 16px;
    top: calc(100% + 2px) !important;
  }

  .LUt8d0T8SkQBdW4_ .p-multiselect-items {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .LUt8d0T8SkQBdW4_ .p-multiselect-items li {
    min-height: 38px;
    border-radius: 10px;
    padding: 12px 14px;
    margin: 0;
    font-size: 14px;
  }

  .Qiqs2RcNuvk9chEY {
    font-size: 14px;
    font-weight: 400;
  }

  .vLF9_KfxJ6gI2GzJ {
    width: 12.71px;
    height: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/Settings/Settings.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;;EAGE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;;EAME,0CAA0C;AAC5C;;AAEA;;;;;;;;EAcE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,gDAAgD;EAChD,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,gDAAgD;EAChD,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,kCAAkC;EAClC,2DAA2D;EAC3D,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,6CAA6C;EAC7C,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,6CAA6C;EAC7C,qCAAqC;EACrC,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;;;EAGE,2CAA2C;EAC3C,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,QAAQ;EACV;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,8BAA8B;IAC9B,4CAA4C;EAC9C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,4CAA4C;EAC9C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,SAAS;EACX;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;;IAEE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;AACF","sourcesContent":[".pageWrapper {\r\n  width: 1184px;\r\n  max-width: 100%;\r\n  margin: 0 auto;\r\n  padding: 40px 0 96px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.title {\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 600;\r\n  font-size: 32px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  text-transform: capitalize;\r\n  color: rgba(0, 0, 0, 1);\r\n  margin: 0 0 16px;\r\n}\r\n\r\n.description {\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  color: rgba(0, 0, 0, 0.7);\r\n  margin: 0 0 40px;\r\n}\r\n\r\n.sectionTitle {\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  text-transform: uppercase;\r\n  color: rgba(0, 0, 0, 0.6);\r\n  margin: 0 0 8px;\r\n}\r\n\r\n.sectionGap {\r\n  height: 32px;\r\n}\r\n\r\n.card {\r\n  background: rgba(249, 249, 249, 1);\r\n  border-radius: 16px;\r\n  padding: 8px 24px;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.04);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.subCard {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 16px 0;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.subCard:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.iconBox {\r\n  width: 56px;\r\n  height: 56px;\r\n  background: rgba(238, 241, 255, 1);\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.iconBox img {\r\n  width: 24px;\r\n  height: 24px;\r\n  display: block;\r\n}\r\n\r\n.iconBox :global(.pi) {\r\n  font-size: 24px;\r\n  color: rgba(32, 51, 108, 1);\r\n}\r\n\r\n.subCardText {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.subCardTitle {\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 500;\r\n  font-size: 20px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  color: rgba(0, 0, 0, 1);\r\n}\r\n\r\n.subCardDescription {\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  color: rgba(0, 0, 0, 0.7);\r\n}\r\n\r\n.switch {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.switch :global(.p-inputswitch) {\r\n  width: 51px;\r\n  height: 31px;\r\n}\r\n\r\n.switch :global(.p-inputswitch .p-inputswitch-slider) {\r\n  border-radius: 100px !important;\r\n  background: rgba(0, 0, 0, 0.16) !important;\r\n  transition: background-color 0.2s !important;\r\n}\r\n\r\n.switch :global(.p-inputswitch .p-inputswitch-slider:before) {\r\n  width: 25px;\r\n  height: 25px;\r\n  margin-top: -12.5px;\r\n  left: 3px;\r\n  background: #ffffff;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.switch :global(.p-inputswitch.p-highlight .p-inputswitch-slider),\r\n.switch :global(.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider) {\r\n  background: rgba(32, 51, 108, 1) !important;\r\n}\r\n\r\n.switch :global(.p-inputswitch.p-highlight .p-inputswitch-slider:before),\r\n.switch\r\n  :global(.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before) {\r\n  transform: translateX(20px);\r\n  background: #ffffff;\r\n}\r\n\r\n.switch :global(.p-inputswitch:not(.p-disabled):hover .p-inputswitch-slider),\r\n.switch\r\n  :global(\r\n    .p-inputswitch:not(.p-disabled):has(.p-inputswitch-input:hover)\r\n      .p-inputswitch-slider\r\n  ) {\r\n  background: rgba(0, 0, 0, 0.24) !important;\r\n}\r\n\r\n.switch\r\n  :global(\r\n    .p-inputswitch.p-highlight:not(.p-disabled):hover .p-inputswitch-slider\r\n  ),\r\n.switch\r\n  :global(\r\n    .p-inputswitch.p-highlight:not(.p-disabled):has(.p-inputswitch-input:hover)\r\n      .p-inputswitch-slider\r\n  ),\r\n.switch\r\n  :global(\r\n    .p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover\r\n      .p-inputswitch-slider\r\n  ) {\r\n  background: #1a2a5a !important;\r\n}\r\n\r\n.allergiesWrapper {\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n\r\n.allergiesWrapper :global(.p-multiselect) {\r\n  width: 100%;\r\n  min-height: 66px;\r\n  border-radius: 24px;\r\n  background: rgba(255, 255, 255, 1);\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  border: none !important;\r\n  outline: none !important;\r\n  display: flex;\r\n  align-items: stretch;\r\n}\r\n\r\n.allergiesWrapper :global(.p-multiselect-label-container) {\r\n  overflow: visible;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.allergiesWrapper :global(.p-multiselect:not(.p-disabled).p-focus),\r\n.allergiesWrapper :global(.p-multiselect:not(.p-disabled):hover) {\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  border: none !important;\r\n  outline: none !important;\r\n}\r\n\r\n.allergiesWrapper :global(.p-multiselect-label) {\r\n  padding: 10px 60px 10px 26px;\r\n  font-family: Roboto, sans-serif;\r\n  font-size: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  height: auto;\r\n  white-space: normal;\r\n}\r\n\r\n.allergiesWrapper :global(.p-multiselect-token) {\r\n  height: 46px;\r\n  background: rgba(32, 51, 108, 0.15);\r\n  color: rgba(48, 48, 48, 1);\r\n  border-radius: 23px;\r\n  padding: 0 18px;\r\n  margin: 0;\r\n  font-family: Jost, Roboto, sans-serif;\r\n  font-weight: 400;\r\n  font-size: 21px;\r\n  line-height: 1;\r\n  letter-spacing: 0;\r\n  text-align: center;\r\n  text-transform: capitalize;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.allergiesWrapper :global(.p-multiselect-token .p-multiselect-token-label) {\r\n  flex: none;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  line-height: 1;\r\n}\r\n\r\n.allergiesWrapper :global(.p-multiselect-token-icon) {\r\n  color: rgba(48, 48, 48, 1);\r\n  width: 11px;\r\n  height: 11px;\r\n  font-size: 11px;\r\n  margin: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.allergiesWrapper :global(.p-multiselect-token-icon svg) {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.allergiesWrapper :global(.p-multiselect-trigger) {\r\n  width: 60px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  padding-right: 30px;\r\n  box-sizing: border-box;\r\n  color: rgba(164, 164, 164, 1);\r\n}\r\n\r\n.allergiesWrapper :global(.p-multiselect-trigger-icon),\r\n.allergiesWrapper :global(.p-multiselect-trigger svg) {\r\n  width: 30px;\r\n  height: 12px;\r\n  color: rgba(164, 164, 164, 1);\r\n}\r\n\r\n.allergiesPanel {\r\n  position: absolute !important;\r\n  top: calc(100% + 8px) !important;\r\n  left: 0 !important;\r\n  right: 0 !important;\r\n  width: 100% !important;\r\n  transform: none !important;\r\n  border-radius: 24px;\r\n  background: rgba(255, 255, 255, 1);\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06) !important;\r\n  padding: 24px;\r\n  overflow: hidden;\r\n  z-index: 1000;\r\n  border: none !important;\r\n}\r\n\r\n.allergiesPanel :global(.p-multiselect-header) {\r\n  display: none;\r\n}\r\n\r\n.allergiesPanel :global(.p-multiselect-items-wrapper) {\r\n  max-height: none !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n.allergiesPanel :global(.p-multiselect-items) {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.allergiesPanel :global(.p-multiselect-items) li {\r\n  min-height: 57px;\r\n  border-radius: 15px;\r\n  margin: 4px 0;\r\n  padding: 0 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 400;\r\n  font-size: 21px;\r\n  line-height: 100%;\r\n  letter-spacing: 0;\r\n  text-transform: capitalize;\r\n  color: rgba(48, 48, 48, 1);\r\n  background: rgba(255, 255, 255, 1) !important;\r\n  border: 1px solid transparent;\r\n  transition: border-color 0.15s;\r\n}\r\n\r\n.allergiesPanel :global(.p-multiselect-item) > span:not(.p-ink) {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.allergiesPanel :global(.p-multiselect-checkbox) {\r\n  display: none;\r\n}\r\n\r\n.allergiesPanel\r\n  :global(.p-multiselect-item:not(.p-highlight):not(.p-disabled):hover),\r\n.allergiesPanel :global(.p-multiselect-item.p-focus:not(.p-highlight)) {\r\n  background: rgba(255, 255, 255, 1) !important;\r\n  color: rgba(48, 48, 48, 1) !important;\r\n  border: 1px solid rgba(32, 51, 108, 1) !important;\r\n  border-radius: 15px;\r\n}\r\n\r\n.allergiesPanel :global(.p-multiselect-item.p-highlight),\r\n.allergiesPanel :global(.p-multiselect-item.p-highlight:hover),\r\n.allergiesPanel :global(.p-multiselect-item.p-highlight.p-focus) {\r\n  background: rgba(32, 51, 108, 1) !important;\r\n  color: rgba(255, 255, 255, 1) !important;\r\n  border: 1px solid transparent !important;\r\n}\r\n\r\n.allergyItem {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  gap: 12px;\r\n}\r\n\r\n.allergyItemLabel {\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 400;\r\n  font-size: 21px;\r\n  line-height: 100%;\r\n  letter-spacing: 0;\r\n  text-transform: capitalize;\r\n  color: rgba(48, 48, 48, 1);\r\n}\r\n\r\n.allergyItemCheck {\r\n  width: 27px;\r\n  height: 19.5px;\r\n  flex-shrink: 0;\r\n  display: block;\r\n}\r\n\r\n@media screen and (max-width: 1240px) {\r\n  .pageWrapper {\r\n    padding-left: 28px;\r\n    padding-right: 28px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .pageWrapper {\r\n    padding: 32px 24px 80px;\r\n  }\r\n\r\n  .allergiesWrapper :global(.p-multiselect-label) {\r\n    padding: 10px 56px 10px 20px;\r\n    gap: 8px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .pageWrapper {\r\n    padding: 24px 16px 80px;\r\n  }\r\n\r\n  .title {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .description {\r\n    font-size: 12px;\r\n    margin-bottom: 32px;\r\n  }\r\n\r\n  .sectionTitle {\r\n    font-size: 12px;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .card {\r\n    padding: 16px;\r\n  }\r\n\r\n  .subCard {\r\n    gap: 10px;\r\n  }\r\n\r\n  .subCardTitle {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .subCardDescription {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .iconBox {\r\n    width: 48px;\r\n    height: 48px;\r\n    padding: 12px;\r\n  }\r\n\r\n  .iconBox img {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n\r\n  .allergiesWrapper :global(.p-multiselect) {\r\n    min-height: 56px;\r\n    border-radius: 18px;\r\n  }\r\n\r\n  .allergiesWrapper :global(.p-multiselect-label) {\r\n    padding: 8px 48px 8px 16px;\r\n    gap: 8px;\r\n  }\r\n\r\n  .allergiesWrapper :global(.p-multiselect-token) {\r\n    height: 38px;\r\n    padding: 0 14px;\r\n    font-size: 16px;\r\n    border-radius: 19px;\r\n    gap: 10px;\r\n  }\r\n\r\n  .allergiesWrapper :global(.p-multiselect-trigger) {\r\n    width: 48px;\r\n    justify-content: flex-end;\r\n    padding-right: 24px;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .allergiesWrapper :global(.p-multiselect-trigger-icon),\r\n  .allergiesWrapper :global(.p-multiselect-trigger svg) {\r\n    width: 22px;\r\n    height: 10px;\r\n  }\r\n\r\n  .allergiesPanel {\r\n    padding: 16px;\r\n    border-radius: 18px;\r\n  }\r\n\r\n  .allergiesPanel :global(.p-multiselect-items) li {\r\n    min-height: 48px;\r\n    padding: 0 16px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .allergyItemLabel {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .allergyItemCheck {\r\n    width: 22px;\r\n    height: 16px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .pageWrapper {\r\n    padding: 32px 24px;\r\n  }\r\n\r\n  .sectionGap {\r\n    height: 24px;\r\n  }\r\n\r\n  .card {\r\n    padding: 16px;\r\n  }\r\n\r\n  .subCard {\r\n    padding: 16px 0;\r\n    gap: 12px;\r\n    justify-content: space-between;\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\r\n  }\r\n\r\n  .subCard:first-child {\r\n    padding-top: 0;\r\n  }\r\n\r\n  .subCard:last-child {\r\n    padding-top: 0;\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\r\n  }\r\n\r\n  .iconBox {\r\n    width: 48px;\r\n    height: 48px;\r\n    padding: 12px;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .iconBox img {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n\r\n  .subCardText {\r\n    gap: 8px;\r\n  }\r\n\r\n  .subCardTitle {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .subCardDescription {\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n  }\r\n\r\n  .switch :global(.p-inputswitch) {\r\n    width: 51px;\r\n    height: 31px;\r\n  }\r\n\r\n  .switch :global(.p-inputswitch .p-inputswitch-slider:before) {\r\n    width: 25px;\r\n    height: 25px;\r\n    margin-top: -12.5px;\r\n    left: 3px;\r\n  }\r\n\r\n  .switch :global(.p-inputswitch.p-highlight .p-inputswitch-slider:before),\r\n  .switch\r\n    :global(.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before) {\r\n    transform: translateX(20px);\r\n  }\r\n\r\n  .allergiesWrapper :global(.p-multiselect) {\r\n    min-height: 44px;\r\n    border-radius: 16px;\r\n    background: rgba(249, 249, 249, 0.98);\r\n  }\r\n\r\n  .allergiesWrapper :global(.p-multiselect-label) {\r\n    padding: 7px 22px 7px 12px;\r\n    gap: 4px;\r\n  }\r\n\r\n  .allergiesWrapper :global(.p-multiselect-token) {\r\n    height: 30px;\r\n    padding: 0 9.78px;\r\n    font-size: 13.7px;\r\n    border-radius: 15px;\r\n    gap: 8px;\r\n  }\r\n\r\n  .allergiesWrapper :global(.p-multiselect-token-icon) {\r\n    width: 8px;\r\n    height: 8px;\r\n    font-size: 8px;\r\n  }\r\n\r\n  .allergiesWrapper :global(.p-multiselect-trigger) {\r\n    width: 32px;\r\n    justify-content: flex-end;\r\n    padding-right: 16px;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .allergiesWrapper :global(.p-multiselect-trigger-icon),\r\n  .allergiesWrapper :global(.p-multiselect-trigger svg) {\r\n    width: 14.74px;\r\n    height: 8.31px;\r\n  }\r\n\r\n  .allergiesPanel {\r\n    padding: 16px;\r\n    border-radius: 16px;\r\n    top: calc(100% + 2px) !important;\r\n  }\r\n\r\n  .allergiesPanel :global(.p-multiselect-items) {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n\r\n  .allergiesPanel :global(.p-multiselect-items) li {\r\n    min-height: 38px;\r\n    border-radius: 10px;\r\n    padding: 12px 14px;\r\n    margin: 0;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .allergyItemLabel {\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n  }\r\n\r\n  .allergyItemCheck {\r\n    width: 12.71px;\r\n    height: 13px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `NGOjDCY3Hs7ji9dl`;
export var title = `iDtCm0HkRlA9tE5R`;
export var description = `PJM0I6PcsEhLGUCl`;
export var sectionTitle = `mbrHImJ_DFQaMHwM`;
export var sectionGap = `pZmoZqOtbB44O8Pw`;
export var card = `dQQolFZwrA078IiA`;
export var subCard = `s0KTWJoQTIZiqXFZ`;
export var iconBox = `oXnrxAbxa2AXl0lR`;
export var subCardText = `vOSiXovSGgkV_Bnr`;
export var subCardTitle = `oaIaqAaR0UEGBso2`;
export var subCardDescription = `nyipSZWx2lQfKBDA`;
var _1 = `FShdQLvNJo173l8D`;
export { _1 as "switch" };
export var allergiesWrapper = `QFFE4j0kHw0p4h7O`;
export var allergiesPanel = `LUt8d0T8SkQBdW4_`;
var _2 = `IxTMDWD4jFEFMxdl`;
export { _2 as "p-ink" };
export var allergyItem = `nOn2Sb3E5k1y2Ya5`;
export var allergyItemLabel = `Qiqs2RcNuvk9chEY`;
export var allergyItemCheck = `vLF9_KfxJ6gI2GzJ`;
export default ___CSS_LOADER_EXPORT___;
